import { CaretDownFilled } from '@ant-design/icons';
import classNames from 'classnames';
import classes from './SelectBlueArrowIcon.module.scss';

export const SelectBlueArrowIcon = () => {
  return <CaretDownFilled className={classNames(classes.blueArrowIcon, 'ant-select-suffix')} />;
};
